// extracted by mini-css-extract-plugin
export default {"btnContainer":"DataTable_btnContainer__oU+li","viewBtn":"DataTable_viewBtn__2BGTe"};